import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import WebriQForm from "@webriq/gatsby-webriq-form"

import pdfIcon from "../images/pdf.png"

const Worksheet = () => (
  <Layout>
    <SEO
      title="Worksheet"
      description="Building Bridges to Your Possibilities."
    />
    <div className="container-fluid page-head about-us text-center">
      <div className="container p-relative page-heading">
        <div>
          <h1 className="inner-page-h1 font-weight-bold">Worksheet</h1>
        </div>
      </div>
      <div className="row heading-blocks"></div>
    </div>
    <div className="page-body" style={{ maxWidth: "1140px", margin: "0 auto" }}>
      <div className="row">
        <div className="col-lg-6">
          <div className="contact-clean" style={{ paddingTop: "0" }}>
            <WebriQForm
              name="Contact Form"
              className="webriq-form"
              data-form-id="71872451-5c36-43c0-b9e7-d83430e5ded9"
              data-thankyou-url="/thank-you"
            >
              <h2 className="mt-2 mb-0">More Resources</h2>
              <h4 className="mt-2 mb-5">Change begins with you!</h4>
              <div className="form-group">
                <input
                  type="text"
                  name="Name"
                  className="form-control"
                  id="InputName"
                  placeholder="Enter Name"
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="Email Address"
                  className="form-control"
                  id="InputEmail1"
                  aria-describedby="emailHelp"
                  placeholder="Enter email"
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="Phone Number"
                  className="form-control"
                  id="InputPhone"
                  placeholder="Enter phone"
                />
              </div>

              <div className="form-group">
                <textarea
                  name="Message"
                  className="form-control h-auto"
                  id="InputMessage"
                  rows={4}
                  placeholder="Add a comment"
                />
              </div>
              <div className="form-group">
                <div className="webriq-recaptcha" />
              </div>
              <button
                type="submit"
                className="btn-global w-100 hvr-bounce-to-right"
              >
                Submit
              </button>
            </WebriQForm>
          </div>
        </div>
        <div className="col-lg-6 px-5">
          <h4 className="mt-2">
            Not ready for consultation yet? Download our self-discovery
            worksheets to get a better idea of how to prioritize your goals, and
            simplify your life.
          </h4>
          <div className="row text-center">
            <div className="col-lg-12  mt-5">
              <a
                href="https://5305394c-8688-4f58-9bff-f0ad2685d7d3.filesusr.com/ugd/8bffe1_1d15b89a62ff4559b5437d4f344352b0.pdf"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  style={{ width: "100px" }}
                  src={pdfIcon}
                  alt="Additional Resources"
                />
              </a>

              <h5 style={{ width: "200px", margin: "30px auto" }}>
                Business Planning Process & Points-of-Reference
              </h5>
            </div>
            <div className="col-lg-12  mt-5">
              <a
                href="https://5305394c-8688-4f58-9bff-f0ad2685d7d3.filesusr.com/ugd/8bffe1_2ae5fb854ba3472aafcdb385246b852d.pdf"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  style={{ width: "100px" }}
                  src={pdfIcon}
                  alt="Additional Resources"
                />
                <h5 style={{ width: "200px", margin: "30px auto" }}>
                  Understanding the "Why" of Your Goals
                </h5>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default Worksheet
